export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["प्रपत्र फ़ील्ड संख्या"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आवश्यक आईडी गायब है"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["आपने सफलतापूर्वक लॉग इन कर लिया है, एटीएम पर परिचालन जारी रखें"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["एटीएम से लेनदेन जारी रखें"])}
}